module.exports = __webpack_public_path__ + "img/c06_unitvillager_Normal_ua.49efa64b.webp";